import React, { useState } from 'react'
import './ConfirmArchiveModal.css'

export default function ConfirmArchiveModal({ count, onConfirm, onCancel }) {
  const [deleteAfter, setDeleteAfter] = useState(false)

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="confirm-archive-modal" onClick={e => e.stopPropagation()}>
        <h3>Archive {count} Video{count !== 1 ? 's' : ''}</h3>
        <p>
          Selected videos will be archived to R2 storage as MP4 files.
        </p>

        <label className="delete-after-option">
          <input
            type="checkbox"
            checked={deleteAfter}
            onChange={e => setDeleteAfter(e.target.checked)}
          />
          <span>Delete from Stream after archiving</span>
        </label>

        {deleteAfter && (
          <p className="delete-warning">
            ⚠️ Videos will be removed from Cloudflare Stream once archiving completes.
          </p>
        )}

        <div className="confirm-archive-actions">
          <button className="secondary" onClick={onCancel}>Cancel</button>
          <button className="primary" onClick={() => onConfirm(deleteAfter)}>
            Archive {count} Video{count !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  )
}
